/**
 * 运营 - 白名单管理 - 自由职业者白名单（自由职业者四要素）
 */
<template>
  <div class="whitelist-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>白名单管理</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者白名单</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="姓名">
          <el-input v-model="formInline.freelancerName" placeholder="请输入姓名" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="formInline.identityDocumentNumber" placeholder="请输入身份证号" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formInline.mobile" placeholder="请输入手机号" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="收款账号">
          <el-input v-model="formInline.receiveAccount" placeholder="请输入收款账号" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openFormDialog()">新增</el-button>
      <el-button size="small" icon="el-icon-upload2" @click="openBatchDialog">批量导入</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
        border
      >
        <el-table-column prop="freelancerName" label="姓名" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.freelancerName)"
            >
              {{ scope.row.freelancerName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="identityDocumentNumber" label="身份证号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.identityDocumentNumber)"
            >
              {{ scope.row.identityDocumentNumber || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.mobile)"
            >
              {{ scope.row.mobile || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="receiveAccount" label="收款账号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.receiveAccount)"
            >
              {{ scope.row.receiveAccount || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="signStatusStr" label="签约状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              size="small"
              effect="plain"
              :type="getSignStatusTagType(scope.row.signStatus)"
            >
              {{ scope.row.signStatusStr || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="verificationStatusStr" label="认证状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              size="small"
              effect="plain"
              :type="getVerificationStatusTagType(scope.row.verificationStatus)"
            >
              {{ scope.row.verificationStatusStr || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="openFormDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>

    <!-- 新增/编辑 -->
    <el-dialog
      :title="form.id ? '编辑白名单' : '新增白名单'"
      :visible.sync="formDialogVisible"
      width="520px"
      class="edit-form-dialog"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px">
        <el-form-item label="姓名" prop="freelancerName">
          <el-input
            v-model="form.freelancerName"
            placeholder="请输入姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="身份证号" prop="identityDocumentNumber">
          <el-input
            v-model="form.identityDocumentNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="form.mobile"
            placeholder="请输入手机号"
            clearable
          />
        </el-form-item>
        <el-form-item label="收款账号" prop="receiveAccount">
          <el-input
            v-model="form.receiveAccount"
            placeholder="请输入收款账号"
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="formDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog title="批量导入自由职业者白名单" :visible.sync="batchDialogVisible" width="560px" @close="resetBatch">
      <div class="batch-tip">
        <p>请上传 Excel 文件，表头需包含：姓名、证件号、手机号、收款账号</p>
        <p class="tip-small">支持 .xlsx、.xls 格式，每次仅支持导入一个文件。</p>
      </div>
      <el-upload
        ref="uploadRef"
        class="upload-inline"
        :auto-upload="false"
        :limit="1"
        :show-file-list="true"
        :on-change="onFileChange"
        :on-exceed="onExceed"
        accept=".xlsx,.xls"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">选择文件</el-button>
      </el-upload>
      <p class="tip-small" style="margin-top: 10px;">选择文件后，点击「确定导入」开始上传。</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="batchLoading" @click="submitBatch">确定导入</el-button>
      </span>
    </el-dialog>

    <!-- 导入失败详情 -->
    <el-dialog
      title="导入失败详情"
      :visible.sync="batchErrorVisible"
      width="640px"
    >
      <div class="batch-error-list" v-if="batchErrorList && batchErrorList.length">
        <p class="tip-small">请根据以下提示修正 Excel 后重新导入：</p>
        <el-alert
          title="白名单 Excel 数据验证失败"
          type="error"
          :closable="false"
          show-icon
        />
        <el-scrollbar style="max-height: 300px; margin-top: 10px;">
          <ul>
            <li v-for="(item, index) in batchErrorList" :key="index">
              {{ item }}
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="batchErrorVisible = false">我已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWhitelistList,
  createWhitelist,
  updateWhitelist,
  deleteWhitelist,
  batchImportWhitelist
} from '../../api/userMG';
import Pagination from '../../components/Pagination';

export default {
  name: 'WhitelistList',
  components: { Pagination },
  data() {
    return {
      loading: false,
      submitLoading: false,
      batchLoading: false,
      formDialogVisible: false,
      batchDialogVisible: false,
      listData: [],
      formInline: {
        page: 1,
        pageSize: 20,
        freelancerName: '',
        identityDocumentNumber: '',
        mobile: '',
        receiveAccount: ''
      },
      pageparm: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      form: {
        id: null,
        freelancerName: '',
        identityDocumentNumber: '',
        mobile: '',
        receiveAccount: ''
      },
      formRules: {
        freelancerName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        identityDocumentNumber: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        receiveAccount: [{ required: true, message: '请输入收款账号', trigger: 'blur' }]
      },
      batchFile: null,
      batchErrorVisible: false,
      batchErrorList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      const params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        freelancerName: this.formInline.freelancerName || undefined,
        identityDocumentNumber: this.formInline.identityDocumentNumber || undefined,
        mobile: this.formInline.mobile || undefined,
        receiveAccount: this.formInline.receiveAccount || undefined
      };
      getWhitelistList(params)
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0) && res.data) {
            const d = res.data;
            this.listData = Array.isArray(d) ? d : (d.items || d.list || []);
            this.pageparm.total = d.totalCount != null ? d.totalCount : (d.total || 0);
            this.pageparm.page = d.page != null ? d.page : this.formInline.page;
            this.pageparm.pageSize = d.pageSize != null ? d.pageSize : this.formInline.pageSize;
          } else {
            this.listData = [];
            const msg = (res && (res.msg || res.message)) || '';
            if (msg && res.msg !== 'success') this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.listData = [];
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || '请求失败';
          this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVerificationStatusTagType(status) {
      const val = Number(status);
      if (val === 1) return 'danger'; // 认证失败 红色
      if (val === 2) return 'primary'; // 未认证 蓝色
      if (val === 3) return 'success'; // 认证成功 绿色
      return 'info'; // 其它 灰色
    },
    getSignStatusTagType(status) {
      const val = Number(status);
      if (val === 0) return 'primary'; // 待签约 蓝色
      if (val === 1) return 'danger'; // 签约失败 红色
      if (val === 3) return 'success'; // 签约成功 绿色
      return 'info'; // 其它 灰色
    },
    search() {
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline.freelancerName = '';
      this.formInline.identityDocumentNumber = '';
      this.formInline.mobile = '';
      this.formInline.receiveAccount = '';
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    openFormDialog(row) {
      if (row && row.id != null) {
        this.form = {
          id: row.id,
          freelancerName: row.freelancerName || row.name || '',
          identityDocumentNumber: row.identityDocumentNumber || row.idCard || '',
          mobile: row.mobile || row.phone || '',
          receiveAccount: row.receiveAccount || row.bankCard || ''
        };
      } else {
        this.form = {
          id: null,
          freelancerName: '',
          identityDocumentNumber: '',
          mobile: '',
          receiveAccount: ''
        };
      }
      this.formDialogVisible = true;
    },
    resetForm() {
      this.form = {
        id: null,
        freelancerName: '',
        identityDocumentNumber: '',
        mobile: '',
        receiveAccount: ''
      };
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const api = this.form.id ? updateWhitelist : createWhitelist;
        api(this.form)
          .then((res) => {
            if (res && (res.msg === 'success' || res.code === 0)) {
              this.$message.success(this.form.id ? '修改成功' : '新增成功');
              this.formDialogVisible = false;
              this.getList();
            } else {
              this.$message.error((res && (res.msg || res.message)) || '操作失败');
            }
          })
          .catch((err) => {
            const data = err && err.response && err.response.data;
            this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '操作失败');
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    handleDelete(row) {
      const name = row.freelancerName || row.name || '--';
      const idNo = row.identityDocumentNumber || row.idCard || '';
      const tipText = idNo ? `${name}（${idNo}）` : name;
      this.$confirm(`将删除【${tipText}】的白名单记录，删除后无法恢复，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          deleteWhitelist({ id: row.id })
            .then((res) => {
              if (res && (res.msg === 'success' || res.code === 0)) {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error((res && (res.msg || res.message)) || '删除失败');
              }
            })
            .catch((err) => {
              const data = err && err.response && err.response.data;
              this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '删除失败');
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    openBatchDialog() {
      this.batchFile = null;
      this.batchDialogVisible = true;
    },
    resetBatch() {
      this.batchFile = null;
      this.batchErrorVisible = false;
      this.batchErrorList = [];
      this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
    },
    onFileChange(file) {
      this.batchFile = file && file.raw;
    },
    onExceed() {
      this.$message.warning('仅支持上传一个文件，请先移除已选文件');
    },
    submitBatch() {
      if (!this.batchFile) {
        this.$message.warning('请先选择要导入的文件');
        return;
      }
      this.batchLoading = true;
      const formData = new FormData();
      formData.append('file', this.batchFile);
      batchImportWhitelist(formData)
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            this.$message.success((res.data && res.data.message) || '导入成功');
            this.batchDialogVisible = false;
            this.getList();
          } else {
            const msg = (res && (res.msg || res.message)) || '导入失败';
            const errors = res && Array.isArray(res.data) ? res.data : null;
            if (errors && errors.length) {
              this.batchErrorList = errors;
              this.batchErrorVisible = true;
            }
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || '导入失败';
          const errors = data && Array.isArray(data.data) ? data.data : null;
          if (errors && errors.length) {
            this.batchErrorList = errors;
            this.batchErrorVisible = true;
          }
          this.$message.error(msg);
        })
        .finally(() => {
          this.batchLoading = false;
        });
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(str)
          .then(() => {
            this.$message.success('已复制');
          })
          .catch(() => {
            this.fallbackCopy(str);
          });
      } else {
        this.fallbackCopy(str);
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>
.whitelist-list-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.toolbar {
  margin: 16px 0;
}
.toolbar .el-button + .el-button {
  margin-left: 10px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.edit-form-dialog >>> .el-dialog {
  border-radius: 8px;
}
.edit-form-dialog >>> .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}
.edit-form-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #303133;
}
.edit-form-dialog >>> .el-dialog__body {
  padding: 16px 20px 10px;
}
.edit-form-dialog >>> .el-dialog__body .el-form-item {
  margin-bottom: 12px;
}
.edit-form-dialog >>> .el-dialog__footer {
  padding: 12px 20px 20px;
  text-align: right;
}
.copyable-cell {
  cursor: copy;
  user-select: none;
}
.copyable-cell:hover {
  color: #409eff;
}
.pagination-wrap {
  margin-top: 16px;
}
.batch-tip {
  margin-bottom: 16px;
  color: #606266;
  font-size: 14px;
}
.batch-tip .tip-small {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
.upload-inline {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/whitelistList.vue